<template>
  <div>
    <WidgetsDropdown/>
    <CRow>
      <CCol sm="4" class="col-sam-1">
        <label for="company" class="mx-2 custom-label" >Company:</label>
      </CCol>
      <CCol sm="4">
        <Select id="company" class="form-control" :required="true" v-model="selectedCompany" @change="onChange($event)">
          <option :selected="true">Choose company</option>
          <option v-for="item in companies" v-bind:value="item.id">
            {{item.name}}
          </option>
        </Select>
      </CCol>
      <CCol sm="4">
        <button type="button" class="btn btn-secondary" @click="submit()">Finish</button>
      </CCol>
    </CRow>
    <CCardGroup columns class="card-columns cols-2">

      <CCard>
        <CCardHeader>Resilient Score</CCardHeader>
        <CChartBar
            :datasets="resilientDataset"
            :labels="categories"
        />
      </CCard>

      <CCard>
        <CCardHeader>Polar Area Chart</CCardHeader>
        <CCardBody>
          <CChartPolarArea
              :datasets="polarDataset"
              :options="defaultOptions"
              :labels="categories"
          />
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader>Pie Chart</CCardHeader>
        <CCardBody>
          <CChartPie
            :datasets="pieDataset"
            :labels="categories"
          />
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader>Bar Chart</CCardHeader>
        <CChartBar
            :datasets="barDataset"
            :labels="categories"
        />
      </CCard>
      <CCard>
        <CCardHeader>Radar Chart</CCardHeader>
        <CChartRadar
            :datasets="radarDataset"
            :options="defaultOptions"
            :labels="categories"
        />
      </CCard>

<!--      <CCard>-->
<!--        <CCardHeader>Bar Chart</CCardHeader>-->
<!--        <CRow class="category-row">-->
<!--          <CCol sm="4" class="col-sam-2">-->
<!--            <label for="category" class="mx-2 custom-label" >Category:</label>-->
<!--          </CCol>-->
<!--          <CCol sm="4">-->
<!--            <Select id="company" class="form-control" :required="true" v-model="selectedCategory" @change="onChange($event)">-->
<!--              <option :selected="true">Choose category</option>-->
<!--              <option v-for="item in categoryData" v-bind:value="item.id">-->
<!--                {{item.name}}-->
<!--              </option>-->
<!--            </Select>-->
<!--          </CCol>-->
<!--          <CCol sm="4">-->
<!--            <button type="button" class="btn btn-secondary" @click="submit()">Finish</button>-->
<!--          </CCol>-->
<!--        </CRow>-->
<!--        <CChartBar-->
<!--            :datasets="barDataset"-->
<!--            :labels="categories"-->
<!--        />-->
<!--      </CCard>-->
    </CCardGroup>
  </div>
</template>

<script>
import axios from "axios";
import { CChartPolarArea } from '@coreui/vue-chartjs'
import { CChartPie } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'
import { CChartRadar } from '@coreui/vue-chartjs'
import WidgetsDropdown from './Widgets/WidgetsDropdown'

export default {
  name: 'Dashboard',
  components: {
    CChartPolarArea,
    CChartPie,
    CChartBar,
    CChartRadar,
    WidgetsDropdown
  },
  data () {
    return {
      companies: [],
      categories: [],
      categoryData: [],
      selectedCompany: "",
      selectedCategory: "",
      polarCategories: [],
      progressPerCategory: [],
      result: [],
      polarDataset: [],
      valuess: {
        label: [],
        backgroundColor: [],
        pointBackgroundColor:[],
        pointBorderColor: '',
        pointHoverBackgroundColor: [],
        pointHoverBorderColor: [],
        data: []
      },
      pieDataset: [],
      pieValues: {
        data: [],
        backgroundColor: []
      },
      barDataset: [],
      barValues: {
        data: [],
        backgroundColor: [],
        label: ''
      },
      radarDataset: [],
      radarValues: {
        data: [],
        backgroundColor: [],
        label: [],
        borderColor: [],
        pointBackgroundColor: [],
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: [],
        tooltipLabelColor: [],
      },
      resilientResult: [],
      resilientDataset: [],
      score_per_category: [],
      resilientValues: {
        data: [],
        backgroundColor: [],
        label: ''
      },
      advancedTableKey: 0,
    }
  },
  computed :{
    defaultOptions () {
      return {
        aspectRatio: 1.5
      }
    },
  },
  mounted() {
    document.title = 'Starter Grower | Dashboard'
    this.getCompany()
  },
  methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },
    getCompany() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/companies', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        self.companies = response.data.data
      }).catch(function (error) {
        console.log(error);
      });
    },
    onChange(event) {
      let self = this;
      if (event.target.id === 'company') {
        self.selectedCompany = event.target.value;
        self.result = []
        self.reset()
        self.getProgress()
      } else {
        self.selectedCategory = event.target.value;
        this.getProgressByCategories()
      }
    },
    getProgress() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/_progress/' + self.selectedCompany, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('dashboard', response)
        if (response.data.data.progress === 0) {
          self.reset()
        } else {
          self.result = response.data.data
          self.progressPerCategory = self.result.progress_per_category
          self.getStat()
          self.getScore()
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getStat() {
      let self = this;
      self.reset();
      for (let i = 0; i < self.progressPerCategory.length; i++) {
        if (self.progressPerCategory[i].progress === 0){
          continue
        }
        //polar area chart
        self.valuess.data.push(self.progressPerCategory[i].progress * 100)
        self.valuess.label.push(self.progressPerCategory[i].category)
        self.categories.push(self.progressPerCategory[i].category)

        //pie chart
        self.pieValues.data.push(self.progressPerCategory[i].progress * 100)

        //bar chart
        self.barValues.data.push(self.progressPerCategory[i].progress * 100)
        // self.barValues.label.push(self.progressPerCategory[i].category)

        //radar chart
        self.radarValues.data.push(self.progressPerCategory[i].progress * 100)
        // self.radarValues.label.push(self.progressPerCategory[i].category)

        self.colorGenerator()
      }
      self.polarDataset.push(self.valuess)
      self.pieDataset.push(self.pieValues)

      self.barValues.label = 'Categories'

      self.barDataset.push(self.barValues)
      self.radarDataset.push(self.radarValues)
    },
    colorGenerator() {
      let self = this
      let r = () => Math.floor(256 * Math.random());
      let first = r();
      let second = r();
      let third = r();

      self.valuess.backgroundColor.push(`rgba(${first}, ${second}, ${third}, 0.2)`)
      self.valuess.pointBackgroundColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
      self.valuess.pointHoverBackgroundColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
      self.valuess.pointHoverBorderColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
      self.valuess.pointBorderColor = '#fff'

      //pie chart
      self.pieValues.backgroundColor.push(`rgba(${first}, ${second}, ${third}, 0.2)`)

      //bar chart
      self.barValues.backgroundColor.push(`rgba(${first}, ${second}, ${third}, 0.2)`)

      //resilient score
      self.resilientValues.backgroundColor.push(`rgba(${first}, ${second}, ${third}, 0.2)`)

      //radar chart
      self.radarValues.backgroundColor.push(`rgba(${first}, ${second}, ${third}, 0.2)`)
      self.radarValues.borderColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
      self.radarValues.pointBackgroundColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
      self.radarValues.pointBorderColor = '#fff'
      self.radarValues.pointHoverBackgroundColor = '#fff'
      self.radarValues.pointHoverBorderColor.push(`rgba(${first}, ${second}, ${third}, 1)`)
      self.radarValues.tooltipLabelColor.push(`rgba(${first}, ${second}, ${third}, 1)`)

    },
    getProgressByCategories() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/progress/category/' + self.selectedCategory, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('getProgressByCategories', response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    reset () {
      let self = this;
      self.categories = []

      //polar area chart
      self.valuess.label = []
      self.valuess.backgroundColor = []
      self.valuess.pointBackgroundColor = []
      self.valuess.pointHoverBackgroundColor = []
      self.valuess.pointHoverBorderColor = []
      self.valuess.pointBorderColor = '#fff'
      self.valuess.data = []

      //pie chart
      self.pieValues.data = []
      self.pieValues.backgroundColor = []
      self.pieDataset = []

      //bar chart
      self.barValues.data = []
      self.barValues.label = ''
      self.barValues.backgroundColor= []
      self.barDataset = []

      //radar chart
      self.radarDataset = []
      self.radarValues.data = []
      self.radarValues.label = []
      self.radarValues.backgroundColor = []
      self.radarValues.borderColor = []
      self.radarValues.pointBackgroundColor = []
      self.radarValues.pointBorderColor = '#fff'
      self.radarValues.pointHoverBackgroundColor = '#fff'
      self.radarValues.pointHoverBorderColor = []
      self.radarValues.tooltipLabelColor = []

      //resilient score
      self.resilientDataset = []
      self.resilientValues.backgroundColor = []
      self.resilientValues.label = ''
      self.resilientValues.data = []
    },

    getScore() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/_score/' + self.selectedCompany, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('get score', response)
        self.resilientResult = response.data.data
        self.score_per_category = self.resilientResult.score_per_category
        self.getResilientStat()
      }).catch(function (error) {
        console.log(error);
      });
    },
    getResilientStat() {
      let self = this;
      for (let i = 0; i < self.score_per_category.length; i++) {
        if (self.score_per_category[i].score === 0){
          continue
        }
        //bar chart
        self.resilientValues.data.push(self.score_per_category[i].score * 100)
        // self.resilientValues.label.push(self.score_per_category[i].category)
        // self.resilientValues.label.push('Categories')

        self.colorGenerator()
      }
      self.resilientValues.label = 'Categories'
      self.resilientDataset.push(self.resilientValues)
    },
  }
}
</script>

<style>
.col-sam-1 {
  max-width: 7%;
  margin-bottom: 2%;
}
.custom-label {
  font-weight: bold;
}
.col-sam-2 {
  max-width: 15%;
  margin-bottom: 2%;
}
.category-row {
  margin-top: 2%;
}
</style>
